import { Component, OnInit, QueryList, ViewChild } from '@angular/core';
import { DataTablesModule } from 'angular-datatables';
import { DataTableDirective } from 'angular-datatables';
//import * as _moment from 'moment';
import { logbaseService } from "../../services/logbase.service";
import { ToastrService } from 'ngx-toastr';
import { dataService } from '../../services/data.service';
import { Subject } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from "@ngx-translate/core";

//const moment = (_moment as any).default ? (_moment as any).default : _moment;

@Component({
  selector: 'app-maintainence',
  templateUrl: './maintainence.component.html',
  styleUrls: ['./maintainence.component.scss'],
})

export class MaintainenceComponent implements OnInit {
  modalRef: NgbModalRef;
  maintainceList: any;
  public dateTimeRange: Date[];
  public dateTimeRangeDown: Date[];
  // public timeRange : Time[];
  settings: { bigBanner: boolean; timePicker: boolean; format: string; defaultOpen: boolean; };
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  datatableElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  // parts: newParts[] = [];
  dtTrigger: Subject<any> = new Subject();
  model: any = {};
  users: {};
  userDetails = localStorage.getItem("userDetails");
  userDetJson = JSON.parse(this.userDetails);
  deleteId;
  delSelmsg: any;

  constructor(private modalService: NgbModal, private logbaseService: logbaseService, private dataService: dataService, private toastr: ToastrService, private spinner: NgxSpinnerService, private translate: TranslateService) { }

  ngOnInit() {
    this.spinner.show();
    this.dtOptions = {
      pagingType: 'simple_numbers',
      dom: '<"top"<"row"<"col-md-10 text-right"<"#dtpagination"p>><"col-md-2 text-right"<"#dtlength"l>><"clear">>><"#dtSearch"f>t<"bottom"<"clear">>',
      language: {
        search: "_INPUT_",
        searchPlaceholder: "  Search by: DownTime,UpTime, Message , Comment...",
        paginate: {
          first: "",
          last: "",
          previous: "<",
          next: ">"
        }
      },
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        const self = this;
        // Unbind first in order to avoid any duplicate handler
        // (see https://github.com/l-lin/angular-datatables/issues/87)
        $('td', row).unbind('click');
        $('td', row).bind('click', () => {
          //self.someClickHandler(data);
        });
        return row;
      }
    };

    this.logbaseService.getMaintainenceHistory()
      .subscribe(result => {
        this.maintainceList = result.response;
        this.dtTrigger.next(true);
        this.spinner.hide();
      });

  }

  deleteFieldValue() {
    this.logbaseService.deleteMaintainenceinput(this.deleteId)
      .subscribe(result => {
        this.rerender();
        this.spinner.hide();
        this.modalRef.close();

      });

  }

  deleteRowDetails(deleteDetails, data, message) {
    this.deleteId = data;
    this.delSelmsg = message;
    this.modalRef = this.modalService.open(deleteDetails);
    this.modalRef.result.then((result) => {
    });
  }

  editRowDetails(editDetails, data) {
    function formatTime(hours) {
      var d = new Date(hours),
        hour = '' + (d.getHours()),
        min = '' + (d.getMinutes()),
        sec = '' + (d.getSeconds());
      if (hour.length < 2) hour = '0' + hour;
      if (min.length < 2) min = '0' + min;
      if (sec.length < 2) sec = '0' + min;
      return [hour, min, sec].join(':');
    }

    function formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      return [year, month, day].join('-');
    }

    let fromdownDate = formatDate(this.dateTimeRange);
    let todownDate = formatDate(this.dateTimeRangeDown);
    let fromdownTime = formatTime(this.dateTimeRange);
    let todownTime = formatTime(this.dateTimeRangeDown);
    this.modalRef = this.modalService.open(editDetails);
    this.modalRef.result.then((result) => {

    });
  };

  maintanenceRegister() {
    this.spinner.show();
    let fromdownDate = formatDate(this.dateTimeRange);
    let todownDate = formatDate(this.dateTimeRangeDown);
    let fromdownTime = formatTime(this.dateTimeRange);
    let todownTime = formatTime(this.dateTimeRangeDown);

    function formatTime(hours) {
      var d = new Date(hours),
        hour = '' + (d.getHours()),
        min = '' + (d.getMinutes()),
        sec = '' + (d.getSeconds());
      if (hour.length < 2) hour = '0' + hour;
      if (min.length < 2) min = '0' + min;
      if (sec.length < 2) sec = '0' + min;
      return [hour, min, sec].join(':');
    }

    function formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      return [year, month, day].join('-');
    }

    let maintainceData = {
      message: this.model.message,
      comments: this.model.comment,
      fromDownDate: fromdownDate,
      toDownDate: todownDate,
      fromDownTime: fromdownTime,
      toDownTime: todownTime,
      createBy: this.userDetJson.loginId,
      createdDate: null,
      updatedDate: null,
      updatedBy: null
    }

    this.logbaseService.MaintanenceScheduler(maintainceData)
      .subscribe(result => {

        this.toastr.success(this.translate.instant('Maintainence Scheduler added successfully'));

      });
    this.rerender();
    this.spinner.hide();
    this.modalRef.close();
  }

  public maxlength(element, maxvalue) {
    var q = element.value.split(/[\s]+/).length;
    if (q > maxvalue) {
      var r = q - maxvalue;
      alert("Sorry, you have input " + q + " words into the " +
        "text area box you just completed. It can return no more than " +
        maxvalue + " words to be processed. Please abbreviate " +
        "your text by at least " + r + " words");
      return false;
    }
  }
  rerender() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      this.spinner.show();
      // Call the dtTrigger to rerender again
      this.model.message = [];
      this.model.comment = [];
      this.dateTimeRange = []
      this.dateTimeRangeDown = [];
      this.logbaseService.getMaintainenceHistory()
        .subscribe(result => {
          this.maintainceList = result.response;
          this.dtTrigger.next(true);
          this.spinner.hide();
        });
    });

  }
}
